import { Button, IconRow, SubmissionInfo } from 'components'

import {
  BsArrowRightSquare,
  BsCheckSquare,
  BsExclamationTriangle,
} from 'react-icons/bs'

import { useTranslation } from 'react-i18next'
import useLocalStorageState from 'hooks/use-localstorage-state/use-localstorage-state'
import { SUBMISSIONS_NAME } from 'views/forms/form.constants'
import { Submission } from 'common.types'
import { useOneStop } from 'hooks'

export const VoterRegPartialSuccessScreen = () => {
  const FIND_POLLING_PLACE_URL = process.env.REACT_APP_PLAN_URL ?? ''
  const [submissions] = useLocalStorageState(
    SUBMISSIONS_NAME,
    {} as { [key: string]: any },
  )
  const { isOneStop, goToPlanToVote } = useOneStop()
  const timestamps = Object.keys(submissions).map(Number)
  const mostRecentTimestamp = Math.max(...timestamps)
  const mostRecentValue: Submission =
    submissions[mostRecentTimestamp.toString()]
  const { serverResponse } = mostRecentValue.apiResponse
  const { applicationId, applicationDate } =
    serverResponse?.data?.data?.response
  const { formState } = mostRecentValue
  const { t } = useTranslation(undefined, {
    keyPrefix: `voterRegistrationForm.successScreen`,
  })
  const { t: mibFailureT } = useTranslation(undefined, {
    keyPrefix: `voterRegistrationForm.partialSuccessMibFailureScreen`,
  })
  const buttonWrapperStyle = { marginTop: 30, marginBottom: 40 }
  return (
    <div>
      <IconRow
        icon={BsCheckSquare}
        iconColor="green"
        text={t('success')}
      ></IconRow>
      <SubmissionInfo
        t={t}
        applicationDate={applicationDate}
        applicationId={applicationId}
        formState={formState}
      />
      <p
        style={{ marginLeft: 22, fontSize: 14 }}
        dangerouslySetInnerHTML={{ __html: t(`disclosureTwo`) }}
      ></p>
      <IconRow
        icon={BsExclamationTriangle}
        iconColor="red"
        text={mibFailureT('notAccepted')}
      ></IconRow>
      <IconRow
        icon={BsArrowRightSquare}
        iconColor="blue"
        text={mibFailureT('youStillHaveOptions')}
      ></IconRow>
      <p dangerouslySetInnerHTML={{ __html: mibFailureT('optionOne') }} />
      <p dangerouslySetInnerHTML={{ __html: mibFailureT('optionTwo') }} />
      <div style={buttonWrapperStyle}>
        <Button
          label={mibFailureT('findVotingLocation')}
          onClick={() => {
            if (isOneStop) {
              goToPlanToVote()
            } else {
              window.location.href = FIND_POLLING_PLACE_URL
            }
          }}
          fullWidth={false}
        />
      </div>
      <p dangerouslySetInnerHTML={{ __html: mibFailureT('optionThree') }} />
      <div style={buttonWrapperStyle}>
        <Button
          label={mibFailureT('findPollingPlace')}
          onClick={() => {
            if (isOneStop) {
              goToPlanToVote()
            } else {
              window.location.href = FIND_POLLING_PLACE_URL
            }
          }}
          fullWidth={false}
        />
      </div>
    </div>
  )
}
